module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Érvényes vonalkódok")]), _vm._v(" "), (_vm.barcodes.length > 0) ? _c('TabulatorTable', {
    attrs: {
      "options": _vm.tabulator_opts
    },
    model: {
      value: (_vm.barcodes),
      callback: function($$v) {
        _vm.barcodes = $$v
      },
      expression: "barcodes"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05e73282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/barcodes.vue
// module id = 279
// module chunks = 0